module.exports = __webpack_public_path__ + "static/ben-1b2c89b64ba26a8dea5a17e02014acd9.png";